import { Box } from '@mui/material';
import { bazaarCanopySrc } from '../../assets/bazzar';

export default function BazaarCanopy() {
  return (
    <Box
      sx={{
        mb: { xs: 1.4, md: 3 },
        mx: 'auto',
        maxWidth: 920,
        px: { xs: 1, md: 0.5 },
      }}
    >
      <Box
        component="img"
        src={bazaarCanopySrc}
        alt="Bazaar canopy"
        sx={{
          width: '100%',
          aspectRatio: '1024 / 84',
          display: 'block',
          objectFit: 'fill',
          filter: 'drop-shadow(0 9px 7px #13001f8a)',
        }}
      />
    </Box>
  );
}
